var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 874 765"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M849 18c-26 17-84 43-113 43-33-37-79-60-130-60-126-1-200 128-176 237-135-4-293-77-381-201-55 101-8 215 54 256-21 2-60-3-78-22-2 68 28 157 139 190-22 12-59 9-76 6 6 57 80 132 162 132A283 283 0 0 1 0 679c83 55 180 86 282 86 283 2 517-245 504-573 27-20 62-54 88-100-15 9-59 27-100 31 26-15 65-65 75-105"
  })));
};
export default SvgTwitter;